import React, {Fragment, useState,useRef} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";

export default function RevenueReport(){
    let state=useSelector((state)=> state);
    const ref=useRef();
    const [DivisionRevenue, setDivisionRevenue]=useState([]);
    const [CircleRevenue, setCircleRevenue]=useState([]);
    const [DataCoEffeciantRevenue, setDataCoEffeciantRevenue]=useState([]);

    const [Column1_Data, setColumn1_Data]=useState(0);
    const [Column2_Data, setColumn2_Data]=useState(0);
    const [Column3_Data, setColumn3_Data]=useState(0);
    const [ColumnCompare_Data, setColumnCompare_Data]=useState(0);

    const [ColumnCoEfficientRevenue, setColumnCoEfficientRevenue]=useState([{}]);
    const [DataLengthRevenue, setDatalengthRevenue]=useState(0);


    const [DataRevenueHistory, setDataRevenueHistory]=useState([]);
    const [ColumnRevenueHistory, setColumnRevenueHistory]=useState([{}]);

    const[BinRevenue, setBinRevenue]=useState()

    const[NameRevenue, setNameRevenue]=useState()
    const [showRevenue, setShowRevenue] = useState(false);


    const handleCloseRevenue = () => setShowRevenue(false);

    const handleShowRevenue = () => setShowRevenue(true);
    const [showSaveMap, setShowSaveMap] = useState(false);
    const handleCloseSaveMap = () => setShowSaveMap(false);
    const handleShowSaveMap = () => setShowSaveMap(true);

    const [showRevenueHistory, setShowRevenueHistory] = useState(false);

    const handleCloseRevenueHistory = () => setShowRevenueHistory(false);
    const handleShowRevenueHistory = () => setShowRevenueHistory(true);



    const[DataStatusRevenue, setDataStatusRevenue]=useState(false);

    const [showManualReturn, setShowManualReturn] = useState(false);

    const handleCloseManualReturn = () => setShowManualReturn(false);
    const handleShowManualReturn = () => setShowManualReturn(true);


    const selectRowRevenue={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setBinRevenue(row['BIN']);
            setNameRevenue(row['Name']);
            handleShowRevenue();
        }
    }
    const getBIN=()=>{
        setDataStatusRevenue(true);
        setDatalengthRevenue(0);
        setColumn1_Data(0);
        setColumn2_Data(0);
        setColumn3_Data(0);
        setColumnCompare_Data(0);

        const Commi=document.getElementById("cmbBinCommiRevenue");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const Division=document.getElementById("cmbBinDivisionRevenue");
        const DivisionValue=Division.options[Division.selectedIndex].text;


        const Circle=document.getElementById("cmbBinCircleRevenue");
        const CircleValue=Circle.options[Circle.selectedIndex].text;

        const Range=document.getElementById("cmbRangeRevenue");
        const RangeValue=Range.options[Range.selectedIndex].text;

        const Items=document.getElementById("cmbItemsRevenue");
        const ItemsValue=Items.options[Items.selectedIndex].text;

        const DataLimit=document.getElementById("cmbDataLimitRevenue");
        const DataLimitValue=DataLimit.options[DataLimit.selectedIndex].text;
        const SearchName=document.getElementById("txtSearchNameRevenue").value;
        const RevenueBin=document.getElementById("txtRevenueBin").value;

        const Col1=document.getElementById("cmbCol1");
        const Col1Value=Col1.options[Col1.selectedIndex].text;

        const Col2=document.getElementById("cmbCol2");
        const Col2Value=Col2.options[Col2.selectedIndex].text;

        const Col3=document.getElementById("cmbCol3");
        const Col3Value=Col3.options[Col3.selectedIndex].text;

        const ColGrowth1=document.getElementById("cmbMonthGrowth1");
        const ColGrowth1Value=ColGrowth1.options[ColGrowth1.selectedIndex].text;

        const ColGrowth2=document.getElementById("cmbMonthGrowth2");
        const ColGrowth2Value=ColGrowth2.options[ColGrowth2.selectedIndex].text;

        const ColGrowth3=document.getElementById("cmbMonthGrowth3");
        const ColGrowth3Value=ColGrowth3.options[ColGrowth3.selectedIndex].text;

        const UptoGrowth=document.getElementById("cmbUptoGrowth");
        const UptoGrowthValue=UptoGrowth.options[UptoGrowth.selectedIndex].text;

        const ComparedMonth=document.getElementById("cmbComparedMonth");
        const ComparedMonthValue=ComparedMonth.options[ComparedMonth.selectedIndex].text;


        let BondRevenue=document.getElementById("cmbBondRevenue");
        let cmbStatus=document.getElementById("cmbStatus");
        let AmountStatus=document.getElementById("cmbAmountStatus");
        let StatusValue=document.getElementById("txtStatusValue").value;

        let getCommi=" ";
        let getDivision=" ";
        let getCircle=" ";
        let getRange="";
        let getItems="";
        let getlimit ;
        let getName="";
        let getBin="";
        let getStatusValue="";
        let getCol1="";
        let getCol2="";
        let getCol3="";
        let getGrowth1="";
        let getGrowth2="";
        let getGrowth3="";
        let getUpToGrowth="";
        let getBondRevenue="";

        if(Col1.selectedIndex!=0){getCol1=" , "+Col1Value+""}
        if(Col2.selectedIndex!=0){getCol2=" , "+Col2Value+""}
        if(Col3.selectedIndex!=0){getCol3=" , "+Col3Value+""}
        if(ColGrowth1.selectedIndex!=0){getGrowth1=" , concat("+ColGrowth1Value+",' %')AS "+ColGrowth1Value+""}
        if(ColGrowth2.selectedIndex!=0){getGrowth2=" , concat("+ColGrowth2Value+",' %')AS "+ColGrowth2Value+""}
        if(ColGrowth3.selectedIndex!=0){getGrowth3=" , concat("+ColGrowth3Value+",' %')AS "+ColGrowth3Value+""}

        if(UptoGrowth.selectedIndex==1){getUpToGrowth=", concat(round((Aug_Growth),1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==2){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth)/2,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==3){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth)/3,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==4){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth)/4,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==5){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth)/5,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==6){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth+Jan_Growth)/6,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==7){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth+Jan_Growth+Feb_Growth)/7,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==8){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth+Jan_Growth+Feb_Growth+Mar_Growth)/8,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==9){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth+Jan_Growth+Feb_Growth+Mar_Growth+Apr_Growth)/9,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==10){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth+Jan_Growth+Feb_Growth+Mar_Growth+Apr_Growth+May_Growth)/10,1),' %') AS '"+UptoGrowthValue+"' "}
        if(UptoGrowth.selectedIndex==11){getUpToGrowth=", concat(round((Aug_growth+Sept_Growth+Oct_Growth+Nov_Growth+Dec_Growth+Jan_Growth+Feb_Growth+Mar_Growth+Apr_Growth+May_Growth+Jun_Growth)/11,1),' %') AS '"+UptoGrowthValue+"' "}



        let jsonObject;

        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommi="And Commissionerate = '"+CommiValue+"'"}}
        else{getCommi="And Commissionerate = '"+state.accessCom+"'"}

        if(state.accessDiv=="All Division"){if(Division.selectedIndex!=0){getDivision="And Division = '"+DivisionValue+" Division'"}}
        else{getDivision="And Division = '"+state.accessDiv+" Division'"}

        if(state.accessCir=="All Circle"){if(Circle.selectedIndex!=0){getCircle="And Circle ='"+CircleValue+"'"}}
        else {getCircle="And Circle = '"+state.accessCir+"'"}

        if(Range.selectedIndex!=0){getRange="And Range_Name ='"+RangeValue+"'"}


    if(Items.selectedIndex!=0){getItems="And Category= '"+ItemsValue+"'"}

    if(SearchName!=""){ getName=" And Name Like '%"+SearchName+"%'"}
        if(RevenueBin!=""){ getBin=" And BIN Like '%"+RevenueBin+"%'"}

        if(cmbStatus.selectedIndex==0){
            if(AmountStatus.selectedIndex==0){getStatusValue=" And "+ComparedMonthValue+"!=0 "}
            if(AmountStatus.selectedIndex==1){getStatusValue=" And "+ComparedMonthValue+"="+StatusValue+""}
            if(AmountStatus.selectedIndex==2){getStatusValue=" And "+ComparedMonthValue+"<="+StatusValue+" And "+ComparedMonthValue+" !=0 "}
            if(AmountStatus.selectedIndex==3){getStatusValue=" And "+ComparedMonthValue+">="+StatusValue+"  "}
        }
         if(cmbStatus.selectedIndex==1){getStatusValue=" And "+ComparedMonthValue+"=0"}
         if(cmbStatus.selectedIndex==2){getStatusValue=""}


        if(BondRevenue.selectedIndex ==1){ getBondRevenue=" And Bond_Licence =1 "}
        if(BondRevenue.selectedIndex ==2){ getBondRevenue=" And Bond_Licence =0 "}



        if(DataLimit.selectedIndex!=0){getlimit=" LIMIT " +DataLimitValue
            jsonObject={"sql":"SELECT Division,Circle,Range_Name,BIN,Name,Address,Category ,Balance AS Current_Balance,"+ComparedMonthValue+" "+getCol1+" "+getCol2+" "+getCol3+" "+getGrowth1+" "+getGrowth2+" "+getGrowth3+" ,Total_25 AS Total_24_25,Total_26 AS Total_25_26 FROM nbr.revenue_25_26_view where 1=1 "+getDivision+" "+getCircle+" "+getRange+" "+getItems+" "+getBin+" "+getName+" "+getStatusValue+" "+getBondRevenue+" ORDER BY "+ComparedMonthValue+" DESC "+getlimit+" "}

        }else{getlimit=""
            jsonObject={"sql":"SELECT Count(BIN)AS Total_BIN FROM nbr.revenue_25_26_view where 1=1 "+getDivision+" "+getCircle+" "+getRange+" "+getItems+" "+getBin+" "+getName+" "+getStatusValue+" "+getBondRevenue+"  "+getlimit+" "}

        }

        setColumnCoEfficientRevenue([{}]);setDataCoEffeciantRevenue([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
           setDatalengthRevenue(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatusRevenue(false)}else {
                await setColumnCoEfficientRevenue(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCoEffeciantRevenue(result);
                let clmn1Data=0;
                let clmn2Data=0;
                let clmn3Data=0;
                let clmncompareData=0;
                 result.map(async (ctr,index)=> {

                      clmncompareData=clmncompareData+ctr[ComparedMonthValue];
                      clmn1Data=clmn1Data+ctr[Col1Value];
                      clmn2Data=clmn2Data+ctr[Col2Value];
                      clmn3Data=clmn3Data+ctr[Col3Value];


                })
                setColumnCompare_Data(ComparedMonthValue +"= "+ clmncompareData);
                 if(Col1.selectedIndex !=0){setColumn1_Data(Col1Value +"= "+ clmn1Data);}
                if(Col2.selectedIndex !=0){setColumn2_Data(Col2Value +"= "+ clmn2Data);}
                if(Col3.selectedIndex !=0){setColumn3_Data(Col3Value +"= "+ clmn3Data);}



                    setDataStatusRevenue(false)
            }
        }).catch(error=>{ setDataStatusRevenue(false);});
    }
    const UpdateFlag=()=>{


        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag=1 where Bin='"+BinRevenue+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Flag saved")

            } else {
                cogoToast.error("Flag not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });


    }
    const updateRevenue=()=>{

        const collectedRevenue=document.getElementById("txtRevenueAmount").value;
        const closingBalance=document.getElementById("txtClosingBalance").value;
        const collectedMonth=document.getElementById("cmbRevenueMonth");
        const collectedMonthValue=collectedMonth.options[collectedMonth.selectedIndex].text;

            let jsonObject={"sql":"Update revenue25_26 set "+collectedMonthValue+"='"+collectedRevenue+"',Balance="+closingBalance+" where BIN='"+BinRevenue+"' "};

        if(collectedMonth.selectedIndex==0){cogoToast.error("Please select month")}else{
            if(collectedRevenue==""){cogoToast.error("Please enter Amount")}else{
            if(closingBalance==""){cogoToast.error("Please enter Closing Balance")}else{


        RestClient.PostRequest(AppUrl.updateData,jsonObject ).then(result => {
            if (result == 1) {
                cogoToast.success("Revenue saved")

            } else {
                cogoToast.error("Data not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });
            }}}
    }

    const getRevenueHistory=(status)=>{

        let jsonObject="";
            if(status==0){

                jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                        ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                        "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+BinRevenue+"' "};
            }else if(status==1){

                jsonObject={"sql":"select FY,Month,round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`,Total_Sales_Value,Total_Payable_Vat,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid from Revenue_Analyse_View where BIN='"+BinRevenue+"' order by Month_Code Desc"}
            }else if(status==2){
                jsonObject={"sql":"select * from BIN where BIN='"+BinRevenue+"' "}

            }else if(status==3){
                jsonObject={"sql":" SELECT HSCODE,Description As Description_Of_Goods,Supply_Qty,Supply_Unit As Unit,Rm_Price,Addition_Price,Addition_Parcentage AS 'Add_%',Total_Price,Entry_Date As 'Effect_Date',DATEDIFF(CURDATE(),Entry_Date) AS Total_Days,Entry_Date,Status,Sale_Category,Comments As Comments_for_goods FROM `Co_Efficient` where BIN='"+BinRevenue+"' "};

            }
            setColumnRevenueHistory([{}]);setDataRevenueHistory([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnRevenueHistory(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataRevenueHistory(result);

                handleShowRevenueHistory();

            }
        }).catch(error=>{ });

    }

    const saveNegative=(status)=>{


        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Neg_Status="+status+" where Bin='"+BinRevenue+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Negative saved")

            } else {
                cogoToast.error("Negative not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });


    }
    const saveMapManually=()=>{

        const mapLat=document.getElementById("txtMapLatitude").value;
        const mapLang=document.getElementById("txtMapLongitude").value;

        if(mapLat==""){cogoToast.error("Please insert Latitude")}else{
        if(mapLang==""){cogoToast.error("Please insert Longitude")}else{



        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Lat="+mapLat+",Lang="+mapLang+" where Bin='"+BinRevenue+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Map saved")

            } else {
                cogoToast.error("Map not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });
        }}

    }
    const saveReturnManually=()=>{


            const TotalSalesValue=document.getElementById("txtTotalSalesValue").value;
            const TotalPayableVat=document.getElementById("txtTotalPayableVat").value;
            const TotalPayableSd=document.getElementById("txtTotalPayableSd").value;
            const TotalInputTaxCreditValue=document.getElementById("txtInputTaxCreditValue").value;
            const TotalInputTaxCreditVat=document.getElementById("txtInputTaxCreditVat").value;
            const IncreasingAdjustment=document.getElementById("txtIncreasingAdjustment").value;
            const DecreasingAdjustment=document.getElementById("txtDecreasingAdjustment").value;
            const NetPayableVat=document.getElementById("txtNetPayableVat").value;
            const NetPayableSd=document.getElementById("txtNetPayableSd").value;
            const DepositedVat=document.getElementById("txtDepositedVat").value;
            const DepositedSd=document.getElementById("txtDepositedSd").value;
           const ClosingBalanceVat=document.getElementById("txtClosingBalanceVat").value;
            const ClosingBalanceSd=document.getElementById("txtClosingBalanceSd").value;
            const VdsIncreasing=document.getElementById("txtVdsIncreasing").value;
           const VdsDecreasing=document.getElementById("txtVdsDecreasing").value;
            const AtPaid=document.getElementById("txtAtPaid").value;
            const MonthCode=document.getElementById("txtMonthCode").value;

        const FY=document.getElementById("cmbFyManualReturn")
        const FyValue=FY.options[FY.selectedIndex].text;
        const Month=document.getElementById("cmbMonthManualReturn")
        const MonthValue=Month.options[Month.selectedIndex].text;

       let jsonObject={"sql":"Insert into Revenue_Data(ID,BIN,FY,Month,Total_Sales_Value,Total_Payable_VAT,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid,Month_Code,Online_return)" +
               "values(NULL,'"+BinRevenue+"','"+FyValue+"','"+MonthValue+"',"+TotalSalesValue+","+TotalPayableVat+","+TotalPayableSd+","+TotalInputTaxCreditValue+","+TotalInputTaxCreditVat+","+IncreasingAdjustment+","+DecreasingAdjustment+","+NetPayableVat+","+NetPayableSd+","+DepositedVat+","+DepositedSd+","+ClosingBalanceVat+","+ClosingBalanceSd+","+VdsIncreasing+","+VdsDecreasing+","+AtPaid+","+MonthCode+",0 ) "};

                if(TotalSalesValue==""){cogoToast.error("Please insert Total Sales Value")}else{
                if(TotalPayableVat==""){cogoToast.error("Please insert Total Payable VAT")}else{
                if(TotalPayableSd==""){cogoToast.error("Please insert Total Payable SD")}else{
                if(TotalInputTaxCreditValue==""){cogoToast.error("Please insert Total Input tax credit value")}else{
                if(TotalInputTaxCreditVat==""){cogoToast.error("Please insert Total input tax credit Vat")}else{
                if(IncreasingAdjustment==""){cogoToast.error("Please insert Increasing Adjustment")}else{
                if(DecreasingAdjustment==""){cogoToast.error("Please insert Decreasing Adjustment")}else{
                if(NetPayableVat==""){cogoToast.error("Please insert Net Payable Vat")}else{
               if(NetPayableSd==""){cogoToast.error("Please insert Net Payable SD")}else{
                if(DepositedVat==""){cogoToast.error("Please insert Depositrd Vat")}else{
               if(DepositedSd==""){cogoToast.error("Please insert Deposited Vat")}else{
               if(ClosingBalanceVat==""){cogoToast.error("Please insert Closing Vat")}else{
               if(ClosingBalanceSd==""){cogoToast.error("Please insert Closing Balance SD")}else{
               if(VdsIncreasing==""){cogoToast.error("Please insert VDS Increasing  ")}else{
                if(VdsDecreasing==""){cogoToast.error("Please insert VDS Decreasing")}else{
                if(AtPaid==""){cogoToast.error("Please insert Total AT")}else{
               if(MonthCode==""){cogoToast.error("Please insert Month")}else{
                if(FY.selectedIndex==0){cogoToast.error("Please insert FY")}else{
              if(Month.selectedIndex==0){cogoToast.error("Please insert Month")}else {


                  RestClient.PostRequest(AppUrl.updateData, jsonObject).then(result => {
                      if (result == 1) {
                          cogoToast.success("Return saved")

                      } else {
                          cogoToast.error("Return not saved")
                      }
                  }).catch(error => {
                      cogoToast.error(error)
                  });
              }}}}}}}}}}}}}}}}}}}


    }
    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCommiRevenue"
                                            onChange={()=>{
                                                setDivisionRevenue([]);
                                                setCircleRevenue([]);
                                                const e = document.getElementById("cmbBinCommiRevenue");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionRevenue(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                <select className="float-start w-100 customfontsize" id="cmbBinDivisionRevenue"
                                        onChange={()=>{
                                            setCircleRevenue([])
                                            const e = document.getElementById("cmbBinDivisionRevenue");
                                            const value = e.options[e.selectedIndex].value;
                                            const dt=state.circle.filter(x => x.Division_Id==value);
                                            setCircleRevenue(dt)


                                        }}
                                >
                                    <option >All Division</option>

                                    {
                                        DivisionRevenue.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }
                                </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                <select className="float-start w-100 customfontsize" id="cmbBinCircleRevenue" >
                                    <option >All Circle</option>

                                    {
                                        CircleRevenue.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }


                                </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbRangeRevenue"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbItemsRevenue"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BOND</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBondRevenue"  >
                                        <option >Both</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchNameRevenue"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtRevenueBin"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Compared</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbComparedMonth">
                                        <option >July_24</option>
                                        <option >August_24</option>
                                        <option >September_24</option>
                                        <option >October_24</option>
                                        <option >November_24</option>
                                        <option >December_24</option>
                                        <option >January_25</option>
                                        <option >February_25</option>
                                        <option >March_25</option>
                                        <option >April_25</option>
                                        <option >May_25</option>
                                        <option >June_25</option>
                                        <option >July_25</option>
                                        <option >August_25</option>
                                        <option >September_25</option>
                                        <option >October_25</option>
                                        <option >November_25</option>
                                        <option >December_25</option>
                                        <option >January_26</option>
                                        <option >February_26</option>
                                        <option >March_26</option>
                                        <option >April_26</option>
                                        <option >May_26</option>
                                        <option >June_26</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Status</label></Col>
                                <Col lg={9}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbStatus" >
                                        <option >Paid Only</option>
                                        <option >Not Paid</option>
                                        <option >Both</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Amount</label></Col>
                                <Col lg={5}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbAmountStatus"  >
                                        <option >All Amount</option>
                                        <option >Equal</option>
                                        <option >Less Than</option>
                                        <option >More Than</option>
                                    </select>
                                </Col>
                                <Col lg={2}xs={4}><label className="text-danger fw-bold">Value</label></Col>
                                <Col lg={1}xs={4}><input type="text" id="txtStatusValue"/></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimitRevenue"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getBIN}>Search</button>
                                </Col>


                            </Row>



                        </div>
                    </Col>

                    <Col lg={9}>
                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                               DataStatusRevenue? <LoadingText/>
                               :<BootstrapTable ref={ref} id="RevenueTable" selectRow={selectRowRevenue}  keyField='BIN' data={DataCoEffeciantRevenue} columns={ColumnCoEfficientRevenue}></BootstrapTable>


                            }
                              </div>

                    </Col>
                    <Row className="mb-2">
                        <Col lg={3}xs={12}><label className="text-primary fs-5 mr-4">Data found: {DataLengthRevenue}</label></Col>
                        <Col lg={8} className=" ml-4">
                            <Row className="mt-2">

                                <Col lg={2}xs={4}>
                                    <select  id="cmbCol1" >
                                        <option >No Month</option>
                                        <option >July_23</option>
                                        <option >August_23</option>
                                        <option >September_23</option>
                                        <option >October_23</option>
                                        <option >November_23</option>
                                        <option >December_23</option>
                                        <option >January_24</option>
                                        <option >February_24</option>
                                        <option >March_24</option>
                                        <option >April_24</option>
                                        <option >May_24</option>
                                        <option >June_24</option>
                                        <option >July_24</option>
                                        <option >August_24</option>
                                        <option >September_24</option>
                                        <option >October_24</option>
                                        <option >November_24</option>
                                        <option >December_24</option>
                                        <option >January_25</option>
                                        <option >February_25</option>
                                        <option >March_25</option>
                                        <option >April_25</option>
                                        <option >May_25</option>
                                        <option >June_25</option>
                                        <option >July_25</option>
                                        <option >August_25</option>
                                        <option >September_25</option>
                                        <option >October_25</option>
                                        <option >November_25</option>
                                        <option >December_25</option>
                                        <option >January_26</option>
                                        <option >February_26</option>
                                        <option >March_26</option>
                                        <option >April_26</option>
                                        <option >May_26</option>
                                        <option >June_26</option>
                                    </select>
                                </Col>

                                <Col lg={2}xs={4}>
                                    <select   id="cmbCol2">
                                        <option >No Month</option>
                                        <option >July_23</option>
                                        <option >August_23</option>
                                        <option >September_23</option>
                                        <option >October_23</option>
                                        <option >November_23</option>
                                        <option >December_23</option>
                                        <option >January_24</option>
                                        <option >February_24</option>
                                        <option >March_24</option>
                                        <option >April_24</option>
                                        <option >May_24</option>
                                        <option >June_24</option>
                                        <option >July_24</option>
                                        <option >August_24</option>
                                        <option >September_24</option>
                                        <option >October_24</option>
                                        <option >November_24</option>
                                        <option >December_24</option>
                                        <option >January_25</option>
                                        <option >February_25</option>
                                        <option >March_25</option>
                                        <option >April_25</option>
                                        <option >May_25</option>
                                        <option >June_25</option>
                                        <option >July_25</option>
                                        <option >August_25</option>
                                        <option >September_25</option>
                                        <option >October_25</option>
                                        <option >November_25</option>
                                        <option >December_25</option>
                                        <option >January_26</option>
                                        <option >February_26</option>
                                        <option >March_26</option>
                                        <option >April_26</option>
                                        <option >May_26</option>
                                        <option >June_26</option>
                                    </select>
                                </Col>

                                <Col lg={2}xs={4}>
                                    <select id="cmbCol3" >
                                        <option >No Month</option>
                                        <option >July_23</option>
                                        <option >August_23</option>
                                        <option >September_23</option>
                                        <option >October_23</option>
                                        <option >November_23</option>
                                        <option >December_23</option>
                                        <option >January_24</option>
                                        <option >February_24</option>
                                        <option >March_24</option>
                                        <option >April_24</option>
                                        <option >May_24</option>
                                        <option >June_24</option>
                                        <option >July_24</option>
                                        <option >August_24</option>
                                        <option >September_24</option>
                                        <option >October_24</option>
                                        <option >November_24</option>
                                        <option >December_24</option>
                                        <option >January_25</option>
                                        <option >February_25</option>
                                        <option >March_25</option>
                                        <option >April_25</option>
                                        <option >May_25</option>
                                        <option >June_25</option>
                                        <option >July_25</option>
                                        <option >August_25</option>
                                        <option >September_25</option>
                                        <option >October_25</option>
                                        <option >November_25</option>
                                        <option >December_25</option>
                                        <option >January_26</option>
                                        <option >February_26</option>
                                        <option >March_26</option>
                                        <option >April_26</option>
                                        <option >May_26</option>
                                        <option >June_26</option>
                                    </select>
                                </Col>

                                <Col lg={5}>
                                    <Row className="mt-2">
                                        <Col lg={4}xs={4}><select  id="cmbMonthGrowth1" >
                                            <option >No Growth</option>
                                            <option >Jul_Growth</option>
                                            <option >Aug_Growth</option>
                                            <option >Sep_Growth</option>
                                            <option >Oct_Growth</option>
                                            <option >Nov_Growth</option>
                                            <option >Dec_Growth</option>
                                            <option >Jan_Growth</option>
                                            <option >Feb_Growth</option>
                                            <option >Mar_Growth</option>
                                            <option >Apr_Growth</option>
                                            <option >May_Growth</option>
                                            <option >Jun_Growth</option>
                                        </select>
                                        </Col>
                                        <Col lg={4}xs={4}><select   id="cmbMonthGrowth2">
                                            <option >No Growth</option>
                                            <option >Jan_Growth</option>
                                            <option >Feb_Growth</option>
                                            <option >Mar_Growth</option>
                                            <option >Apr_Growth</option>
                                            <option >May_Growth</option>
                                            <option >Jun_Growth</option>
                                            <option >Aug_Growth</option>
                                            <option >Sep_Growth</option>
                                            <option >Oct_Growth</option>
                                            <option >Nov_Growth</option>
                                            <option >Dec_Growth</option>
                                        </select>
                                        </Col>
                                        <Col lg={4}xs={4}><select id="cmbMonthGrowth3" >
                                            <option >No Growth</option>
                                            <option >Jan_Growth</option>
                                            <option >Feb_Growth</option>
                                            <option >Mar_Growth</option>
                                            <option >Apr_Growth</option>
                                            <option >May_Growth</option>
                                            <option >Jun_Growth</option>
                                            <option >Aug_Growth</option>
                                            <option >Sep_Growth</option>
                                            <option >Oct_Growth</option>
                                            <option >Nov_Growth</option>
                                            <option >Dec_Growth</option>
                                        </select></Col>

                                    </Row>

                                </Col>

                                <Col lg={1} className="mt-2">
                                    <select defaultValue="Oct_Growth" id="cmbUptoGrowth" >
                                        <option >No Upto Growth</option>
                                        <option >Upto Growth August</option>
                                        <option >Upto Growth September</option>
                                        <option >Upto Growth October</option>
                                        <option >Upto Growth November</option>
                                        <option >Upto Growth December</option>
                                        <option >Upto Growth January</option>
                                        <option >Upto Growth February</option>
                                        <option >Upto Growth March</option>
                                        <option >Upto Growth April</option>
                                        <option >Upto Growth May</option>
                                        <option >Upto Growth June</option>
                                    </select>

                                </Col>


                            </Row>
                        </Col>

                    </Row>
                    <Row className="mb-2">
                        <Col lg={4}xs={12}></Col>
                        <Col lg={2}xs={12}><label className="text-danger fs-5 mr-4">{ColumnCompare_Data}</label></Col>
                        <Col lg={2}xs={12}><label className="text-danger fs-5 mr-4">{Column1_Data}</label></Col>
                        <Col lg={2}xs={12}><label className="text-danger fs-5 mr-4">{Column2_Data}</label></Col>
                        <Col lg={2}xs={12}><label className="text-danger fs-5 mr-4">{Column3_Data}</label></Col>
                    </Row>
                    <Row>


                        <Col lg={6}>
                            <hr/>
                            <Row>
                                <Col lg={3}> <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button " table="RevenueTable" filename="Revenue Report" sheet="Revenue" buttonText="Download Excel"/>
                                </Col>
                                <Col lg={2}><ReactToPrint   trigger={()=><Button className="w-100 mt-1 " >Print</Button>} content={()=>ref.current}  />
                                </Col>
                            </Row>
                              </Col>
                    </Row>

                </Row>

            </div>
            <Modal show={showRevenue} onHide={handleCloseRevenue}>
                <Modal.Header closeButton>
                    <Modal.Title>{NameRevenue}</Modal.Title>


                </Modal.Header>
                <Modal.Body>

                        <label>Collected Month :</label>
                        <select className="w-50 customfontsize"  id="cmbRevenueMonth" >
                                <option >Select Month</option>
                                <option >July_25</option>
                                <option >August_25</option>
                                <option >September_25</option>
                                <option >October_25</option>
                                <option >November_25</option>
                                <option >December_25</option>
                                <option >January_26</option>
                                <option >February_26</option>
                                <option >March_26</option>
                                <option >April_26</option>
                                <option >May_26</option>
                                <option >June_26</option>
                        </select>
                        <hr/>
                    <label>Collected Amount :</label>
                    <input type="text" id="txtRevenueAmount"/>
                    <label>in thousand</label>
                    <hr/>
                    <label>Closing Balance:</label>
                    <input type="text" id="txtClosingBalance"/>
                    <label>in thousand</label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleCloseRevenue}>Close</Button>
                    <Button variant="success" onClick={updateRevenue}>Save</Button>
                    <Button variant="primary" onClick={()=>getRevenueHistory(0)}>Revenue History</Button>
                    <Button variant="danger" onClick={()=>getRevenueHistory(1)}>Revenue Analysis</Button>
                    <Button variant="danger" onClick={()=>getRevenueHistory(2)}>Basic Info</Button>
                    <Button variant="danger" onClick={()=>getRevenueHistory(3)}>4.3</Button>
                    <Button variant="secondary" onClick={()=>saveNegative(0)}>Negative</Button>
                    <Button variant="primary" onClick={()=>saveNegative(1)}>Positive</Button>
                    <Button variant="primary" onClick={handleShowSaveMap}>Add Map</Button>
                    <Button variant="primary" onClick={UpdateFlag}>Flag</Button>
                    <Button variant="danger" onClick={handleShowManualReturn}>Manual Return</Button>


                </Modal.Footer>
            </Modal>
            <Modal show={showRevenueHistory} onHide={handleCloseRevenueHistory} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>
                            <label>{NameRevenue}</label>


                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataRevenueHistory} columns={ColumnRevenueHistory}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseRevenueHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
            <Modal show={showSaveMap} onHide={handleCloseSaveMap}>
                <Modal.Header closeButton>
                    <label>{NameRevenue}</label>
                </Modal.Header>
                <Modal.Body>
                        <div>
                            <label>Latitude:</label>
                            <input type="text" id="txtMapLatitude"/>
                        </div>
                    <hr/>
                    <div>
                        <label>Longitude:</label>
                        <input type="text" id="txtMapLongitude"/>
                    </div>
                    <div>
                        <hr/>
                    </div>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={saveMapManually}>Save</Button>
                    <Button variant="danger" onClick={handleCloseSaveMap}>Close</Button>


                </Modal.Footer>
            </Modal>


            <Modal show={showManualReturn} onHide={handleCloseManualReturn} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>
                    <label>Manual Return for: {NameRevenue}</label>
                </Modal.Header>
                <Modal.Body className="scrollable-x">

                    <div className="wide-content">

                        <Row className="mt-4">
                            <Col>Total Sales Value</Col><Col><input id="txtTotalSalesValue"/></Col>
                            <Col>Total Payable VAT</Col><Col><input id="txtTotalPayableVat"/></Col>
                            <Col>Total Payable SD</Col><Col><input id="txtTotalPayableSd"/></Col>

                        </Row>
                        <Row className="mt-4">
                            <Col>Input_Tax_Credit_Value</Col><Col><input id="txtInputTaxCreditValue"/></Col>
                            <Col>Input_Tax_Credit_VAT</Col><Col><input id="txtInputTaxCreditVat"/></Col>
                            <Col>Increasing_Adjustment</Col><Col><input id="txtIncreasingAdjustment"/></Col>
                        </Row>
                        <Row className="mt-4">
                            <Col>Decreasing_Adjustment</Col><Col><input id="txtDecreasingAdjustment"/></Col>
                            <Col>Net_Payable_VAT</Col><Col><input id="txtNetPayableVat"/></Col>
                            <Col>Net_Payable_SD</Col><Col><input id="txtNetPayableSd"/></Col>
                        </Row>
                        <Row className="mt-4">
                            <Col>Deposited_VAT</Col><Col><input id="txtDepositedVat"/></Col>
                            <Col>Deposited_SD</Col><Col><input id="txtDepositedSd"/></Col>
                            <Col>Closing_Balance_VAT</Col><Col><input id="txtClosingBalanceVat"/></Col>

                        </Row>
                        <Row className="mt-4">
                            <Col>Closing_Balance_SD</Col><Col><input id="txtClosingBalanceSd"/></Col>
                            <Col>VDS_Increasing</Col><Col><input id="txtVdsIncreasing"/></Col>
                            <Col>VDS_Decreasing</Col><Col><input id="txtVdsDecreasing"/></Col>

                        </Row>
                        <Row className="mt-4">
                            <Col>AT_Paid</Col><Col><input id="txtAtPaid"/></Col>
                            <Col>Month</Col>
                            <Col>
                                <select className="w-100 customfontsize"  id="cmbMonthManualReturn" >
                                    <option >All</option>
                                    <option >July</option>
                                    <option >August</option>
                                    <option >September</option>
                                    <option >October</option>
                                    <option >November</option>
                                    <option >December</option>
                                    <option >January</option>
                                    <option >February</option>
                                    <option >March</option>
                                    <option >April</option>
                                    <option >May</option>
                                    <option >June</option>
                                </select>
                        </Col>
                            <Col>Month Code</Col><Col><input id="txtMonthCode"/></Col>


                        </Row>
                        <Row className="mt-4">
                            <Col >FY</Col>
                            <Col>
                                <select className="w-100 customfontsize"  id="cmbFyManualReturn" >
                                    <option >All</option>
                                    <option >25-26</option>
                                    <option >24-25</option>
                                    <option >23-24</option>
                                </select>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                            <Col></Col>
                            <Col></Col>
                        </Row>

                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={saveReturnManually} >Save</Button>
                    <Button variant="danger" onClick={handleCloseManualReturn}>Close</Button>

                </Modal.Footer>
            </Modal>

        </Fragment>

    )
}
